import styled from "styled-components";
import { FlexColumnCentered } from "../configure-app";
import { useMobile } from "../../hooks/useMobile";
import { logos } from "../../data";
import { useEffect, useState } from "react";

export const longName = (abr) => {
  if (abr === "cbd") return "Beavers";
  if (abr === "pen") return "Pandas";
  if (abr === "gla") return "Celtic";
  if (abr === "hur") return "Last Hurrah";
  return "NULL";
};

export const theDead = [
  "Mark Stone",
  "Jack Eichel",
  "Aaron Ekblad",
  "Shea Theodore",
  "Alex Pietrangelo",
  "Aleksander Barkov",
];

const Border = styled.span`
  border: 0.5px solid;
  display: block;
  padding: 3px;
  white-space: nowrap;
  overflow: hidden;
`;
const Name = styled(Border)`
  width: 140px;
  ${(props) =>
    !props.isDead
      ? `
  background: black;
  color: white;`
      : ""}
`;
const Stat = styled(Border)`
  width: 32px;
`;

const PlayerWrap = styled.div`
  display: flex;
`;

const TeamWrap = styled(FlexColumnCentered)`
  padding-bottom: 50px;

  img {
    height: 150px;
    width: 150px;
  }

  h1 {
    text-align: center;
  }
`;

export const Team = ({ team, scores }) => {
  // console.log("🦐 team score", scores[team]);
  // console.log("🦐 team players", data);
  // console.log("🐀", scores);
  const { isMobile } = useMobile();
  // console.log(scores);
  // console.log("NO SCORES?", !scores);
  // console.log("NO TEAM ?");
  const [isSorted, setIsSorted] = useState(false);
  const [sortedScores, setSortedScores] = useState(scores);

  useEffect(() => {
    setSortedScores(scores);
  }, [scores]);

  useEffect(() => {
    setIsSorted(false);
  }, [team]);
  useEffect(() => {
    const handleSortByScores = () => {
      if (isSorted) return;
      // console.log("SORTING BY scores")

      // eslint-disable-next-line no-unused-vars
      const newScores = sortedScores[team].sort((a, b) => {
        // console.log(a.score.score - b.score.score)
        return a.score.score - b.score.score;
      });
      // console.log("🔥 sorted scores", newScores)
      // setSortedScores({ ...sortedScores })
      setIsSorted(true);
    };
    if (!sortedScores || !sortedScores[team]) return;

    handleSortByScores();
  }, [isSorted, sortedScores, team]);
  if (!sortedScores || !sortedScores[team]) return <h1>LOADING</h1>;
  // console.log("🥨", scores[team]);
  // return <h1>READY</h1>;

  return (
    <TeamWrap>
      <h1>
        <img src={logos[team]} alt={team} />
        <br />
        {/* {scores[team]} */}
      </h1>
      <h4>Skaters</h4>
      <PlayerWrap>
        <Name isDead={true}>Name</Name>
        {/* <Stat>#</Stat> */}
        {!isMobile ? (
          <>
            <Stat onClick={() => null}>POS</Stat>
            <Stat>GP</Stat>
          </>
        ) : null}
        <Stat>G </Stat>
        <Stat>A </Stat>
        <Stat>PPP</Stat>
        <Stat>SHG</Stat>
        <Stat>P</Stat>
      </PlayerWrap>
      {sortedScores[team].map
        ? sortedScores[team].reverse().map((p, i) => {
            // console.log(p);
            if (p.data.position.code === "G") return null;
            const isDead = theDead.includes(p.data.person.fullName);
            return (
              <PlayerWrap key={i}>
                <Name isDead={isDead}>{p.data.person.fullName}</Name>
                {!isMobile ? <Stat>{p.data.position.code}</Stat> : null}
                {!isMobile ? <Stat>{p.score.gp}</Stat> : null}
                <Stat>{p.score.g}</Stat>
                <Stat>{p.score.a}</Stat>
                <Stat>{p.score.ppp}</Stat>
                <Stat>{p.score.shg}</Stat>
                <Stat>{p.score.score}</Stat>
              </PlayerWrap>
            );
          })
        : null}
      <h4>Goalies</h4>
      <PlayerWrap>
        <Name isDead={true}>Name</Name>
        {/* <Stat>#</Stat> */}
        {!isMobile ? (
          <>
            <Stat>POS</Stat>
            <Stat>GP</Stat>
          </>
        ) : null}
        <Stat>GS</Stat>
        <Stat>W</Stat>
        <Stat>GA</Stat>
        <Stat>SO</Stat>
        <Stat>P</Stat>
      </PlayerWrap>
      {sortedScores[team].map
        ? sortedScores[team].map((p, i) => {
            // console.log(p);
            if (p.data.position.code !== "G") return null;
            // // console.log("🏈 Player: ", p);
            const isDead = theDead.includes(p.data.person.fullName);

            return (
              <PlayerWrap key={i}>
                <Name isDead={isDead}>{p.data.person.fullName}</Name>
                {!isMobile ? <Stat>{p.data.position.code}</Stat> : null}
                {!isMobile ? <Stat>{p.score.gp}</Stat> : null}
                <Stat>{p.score.gs}</Stat>
                <Stat>{p.score.w}</Stat>
                <Stat>{p.score.ga}</Stat>
                <Stat>{p.score.so}</Stat>
                <Stat>{p.score.score}</Stat>
              </PlayerWrap>
            );
          })
        : null}
    </TeamWrap>
  );
};
